import { render, staticRenderFns } from "./CourseChapter.vue?vue&type=template&id=3ad12c6f&scoped=true&"
import script from "./CourseChapter.vue?vue&type=script&lang=js&"
export * from "./CourseChapter.vue?vue&type=script&lang=js&"
import style0 from "./CourseChapter.vue?vue&type=style&index=0&id=3ad12c6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad12c6f",
  null
  
)

export default component.exports